import '../../../scss/landing/about_us/index.scss';
document.addEventListener('DOMContentLoaded', function () {
    var overlappingBlock = document.querySelector('.overlapping-block');
    if (!overlappingBlock) {
        return;
    }
    document.addEventListener('scroll', function () {
        var scrollSize = window.scrollY;
        if (scrollSize <= 500) {
            overlappingBlock.style.marginTop = "-" + window.scrollY + "px";
        }
    });
});
